import { Component, HostListener, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { EmployeeBankingInformationAPIModel } from 'src/models/api.model'
import { CommonService } from 'src/services/common/common.service'
import { CLEAR_EMPLOYEE_BANKING_INFO, FETCH_EMPLOYEE_BANKING_INFO } from 'src/store/action/employee.action'
import { AppState } from 'src/store/state/app.state'
import {BANKING_INFO_LABEL_MAPPING} from "../../constants/global-constants";

@Component({
  selector: 'app-banking-info',
  templateUrl: './banking-info.component.html',
  styleUrls: ['./banking-info.component.scss']
})
export class BankingInfoComponent implements OnInit {
  readonly INDIA = 'India'
  readonly JAPAN = 'Japan'
  employeeBankingInfoSubscription: Subscription
  bankingInfo: EmployeeBankingInformationAPIModel[]
  employeeId: string = ''

  constructor(private cs: CommonService, private appState: Store<AppState>) {}

  ngOnInit() {
    this.employeeBankingInfoSubscription = this.appState.select('employee').subscribe(response => {
      this.bankingInfo = response?.bankingInfo
    })
  }

  findBankingInfo(employeeId: string) {
    if (!employeeId) {
      return this.cs.showError('Enter Employee ID')
    }
    this.appState.dispatch(CLEAR_EMPLOYEE_BANKING_INFO())

    this.appState.dispatch(FETCH_EMPLOYEE_BANKING_INFO({ employeeId }))
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    this.findBankingInfo(this.employeeId)
  }

  ngOnDestroy() {
    if (this.employeeBankingInfoSubscription) {
      this.employeeBankingInfoSubscription.unsubscribe()
    }
  }

  protected readonly BANKING_INFO_LABEL_MAPPING = BANKING_INFO_LABEL_MAPPING;
}
